export default "__VITE_PUBLIC_ASSET__934d4fb4__"